/*
  <cart-clear-all> — empties the cart after an inline Yes / No confirm.

  POST /cart/clear.js, then:
    drawer    -> re-render the theme's cart markup, the same way
                 component-cart.js does after a quantity change; the theme's
                 observer then marks the drawer empty
    cart page -> reload, so the page shows its own empty state
*/
(function () {
  if (customElements.get('cart-clear-all')) return;

  function refreshDrawer() {
    return fetch('?section_id=helper-cart')
      .then(function (res) { return res.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var form = doc.getElementById('AjaxCartForm');
        var subtotal = doc.getElementById('AjaxCartSubtotal');

        var targetForm = document.getElementById('AjaxCartForm');
        if (targetForm && form) {
          targetForm.innerHTML = form.innerHTML;
          if (typeof targetForm.ajaxifyCartItems === 'function') targetForm.ajaxifyCartItems();
        }
        var targetSubtotal = document.getElementById('AjaxCartSubtotal');
        if (targetSubtotal && subtotal) targetSubtotal.innerHTML = subtotal.innerHTML;

        document.querySelectorAll('[data-header-cart-count]').forEach(function (elm) {
          elm.textContent = '0';
        });
        if (form) {
          var total = form.querySelector('[data-cart-total]');
          if (total) {
            document.querySelectorAll('[data-header-cart-total]').forEach(function (elm) {
              elm.textContent = total.textContent;
            });
          }
        }
      });
  }

  class CartClearAll extends HTMLElement {
    connectedCallback() {
      this.start = this.querySelector('[data-cart-clear-start]');
      this.confirm = this.querySelector('[data-cart-clear-confirm]');

      this.querySelector('[data-cart-clear-open]').addEventListener('click', this.toggle.bind(this, true));
      this.querySelector('[data-cart-clear-no]').addEventListener('click', this.toggle.bind(this, false));
      this.querySelector('[data-cart-clear-yes]').addEventListener('click', this.clear.bind(this));
    }

    toggle(open) {
      this.start.hidden = open;
      this.confirm.hidden = !open;
      var focus = this.querySelector(open ? '[data-cart-clear-no]' : '[data-cart-clear-open]');
      if (focus) focus.focus();
    }

    async clear() {
      if (this.classList.contains('working')) return;
      this.classList.add('working');

      try {
        var res = await fetch('/cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
        });
        if (!res.ok) throw new Error('cart/clear ' + res.status);

        if (this.dataset.instance === 'page') {
          window.location.reload();
          return;
        }
        await refreshDrawer();
      } catch (e) {
        // Fall back to the page the theme renders from scratch.
        window.location.reload();
        return;
      }

      this.classList.remove('working');
      this.toggle(false);
    }
  }

  customElements.define('cart-clear-all', CartClearAll);
})();
